import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativePage extends cc.Component {

    @property({type:cc.Prefab,displayName:"breed预制体"})
    breedPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"银行预制体"})
    bankPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"开店业务界面"})
    shopPrefab:cc.Prefab = null;

    //养殖
    onBtnCultivation(){
        let page:cc.Node = cc.instantiate(this.breedPrefab);
        page.setParent(O1HD.Canvas());
    }

    // 银行
    onBtnBank(){
        let page:cc.Node = cc.instantiate(this.bankPrefab);
        page.setParent(O1HD.Canvas());
    }

    //开店
    onBtnSetUpShop(){
        let page:cc.Node = cc.instantiate(this.shopPrefab);
        page.setParent(O1HD.Canvas());
    }

    onDisable(){
        O1HD.emit("normalMode.onBackNormal","hzs");
    }

    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
